<template>
  <v-sheet
    v-if="items.length"
    id="nossos-servicos"
    class="position-relative items"
    color="primary lighten-4"
  >
    <v-sheet
      class="py-10 py-md-13 py-lg-16 px-3 mx-auto"
      color="transparent"
      max-width="970px"
    >
      <TitleWidget :title="title" dark></TitleWidget>

      <div class="mt-6 mt-md-8 grid-list">
        <ServiceCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
        />
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ServiceCard from "../cards/ServiceCard.vue";

const _config = {
  mod: "services",
};

const _data = {
  title: "NOSSOS SERVIÇOS",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    ServiceCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  @media screen and (min-width: 1280px) {
    &:before,
    &:after {
      background-repeat: no-repeat;
      background-size: contain;
      content: "";
      position: absolute;
    }

    &:before {
      background-image: url(../../assets/img/service-left-bg.png);
      background-position: top left;
      height: 595px;
      left: 0;
      top: calc(100% - 1px);
      width: 7vw;
    }

    &:after {
      background-image: url(../../assets/img/service-right-bg.png);
      background-position: bottom right;
      bottom: calc(100% - 1px);
      height: 622px;
      right: 0;
      width: 9vw;
    }
  }
}

.grid-list {
  display: grid;
  gap: 75px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 959.9px) {
    gap: 30px;
  }

  @media screen and (max-width: 599.9px) {
    gap: 30px 12px;
    grid-template-columns: repeat(2, calc(50% - 6px));
  }
}
</style>
